module.exports = __webpack_public_path__ + "img/calendar_fill.e2e93e18.svg";